import React from 'react'
// Local
import { CONDITION } from '../../../constant'
import { EncounterConditionDisplay } from '../../authenticated/types'

type Props = {
  condition: EncounterConditionDisplay
}

function ConditionDismissed(
  props: Props
): JSX.Element | null {
  const { condition } = props
  if (condition.conditionCode === CONDITION.CODE.DISMISSED) {
    return (
      <span className="italic">
        Dismissed by Provider
      </span>
    )
  } 
  return null
  
}

export default ConditionDismissed
